"use client";

import type { ComponentProps } from "react";
import { Toaster as Sonner, toast as toastPrimitive } from "sonner";
import { AlertCircle, CheckCircle, InfoCircle } from "../icons";

const toast = toastPrimitive;

const Toaster = ({ ...props }: ComponentProps<typeof Sonner>) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CheckCircle className="text-primary-700 h-4 w-4" />,
        error: <AlertCircle className="text-error-700 h-4 w-4" />,
        info: <InfoCircle className="h-4 w-4 text-blue-700" />,
        warning: <AlertCircle className="text-warning-700 h-4 w-4" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          icon: "mt-[3px]",
          toast:
            "group toast text-sm bg-white text-grey-700 border-grey-200 shadow-lg p-4 rounded-lg border-grey-200 border w-full flex items-start gap-1",
          title: "font-medium",
          description: "text-grey-500",
          actionButton:
            "border border-grey-300 px-2 py-1 rounded-md text-sm font-medium text-grey-700 hover:bg-grey-100 self-center",
          cancelButton: "bg-grey-100 text-grey-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
